<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string;
  }>(),
  {
    title: 'MX Tool',
  },
);
</script>

<template>
  <span
    class="mx-tool-logo inline-flex h-full max-h-full min-h-0 max-w-44 items-center text-black sm:max-w-50 dark:text-white [&_svg]:block [&_svg]:h-full [&_svg]:w-auto"
    role="img"
    :aria-label="title"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="mx-tool-logo__svg h-full w-auto"
      viewBox="0 0 550.5 145"
      preserveAspectRatio="xMidYMid meet"
      focusable="false"
      aria-hidden="true"
    >
      <g class="mx-tool-logo__loop">
        <path
          d="M92.476 62.947C92.4758 46.6389 79.2551 33.4188 62.947 33.4188C46.639 33.4189 33.4189 46.639 33.4188 62.947C33.4188 79.2552 46.6389 92.4758 62.947 92.476C79.2552 92.476 92.476 79.2552 92.476 62.947ZM125.894 62.947C125.894 97.7117 97.7117 125.894 62.947 125.894C28.1824 125.894 0 97.7116 0 62.947C0.000133939 28.1825 28.1825 0.000164441 62.947 3.05176e-05C97.7116 3.05176e-05 125.894 28.1824 125.894 62.947Z"
          fill="#056EF5"
        />
        <path
          d="M390.502 42.4503V49.2957C394.336 45.1885 401.318 40.8074 411.175 40.8074C430.069 40.8074 445.95 56.5519 445.95 77.9097C445.95 99.2674 430.069 115.012 411.175 115.012C401.318 115.012 394.336 110.631 390.502 106.524V144.234H365.037V42.4503H390.502ZM420.622 77.9097C420.622 69.1475 414.187 62.302 405.288 62.302C396.389 62.302 389.955 69.1475 389.955 77.9097C389.955 86.6718 396.389 93.5172 405.288 93.5172C414.187 93.5172 420.622 86.6718 420.622 77.9097Z"
          fill="currentColor"
        />
        <path
          d="M280.207 77.9096C280.207 56.1411 298.279 40.8073 319.089 40.8073C339.899 40.8073 357.971 56.1411 357.971 77.9096C357.971 99.6781 339.899 115.012 319.089 115.012C298.279 115.012 280.207 99.6781 280.207 77.9096ZM303.755 77.9096C303.755 86.6717 310.19 93.5172 319.089 93.5172C327.988 93.5172 334.423 86.6717 334.423 77.9096C334.423 69.1474 327.988 62.302 319.089 62.302C310.19 62.302 303.755 69.1474 303.755 77.9096Z"
          fill="currentColor"
        />
        <path
          d="M198.146 77.9096C198.146 56.1412 216.218 40.8074 237.029 40.8074C257.839 40.8074 275.911 56.1412 275.911 77.9096C275.911 99.6781 257.839 115.012 237.029 115.012C216.218 115.012 198.146 99.6781 198.146 77.9096ZM221.695 77.9096C221.695 86.6718 228.13 93.5172 237.029 93.5172C245.928 93.5172 252.362 86.6718 252.362 77.9096C252.362 69.1475 245.928 62.302 237.029 62.302C228.13 62.302 221.695 69.1475 221.695 77.9096Z"
          fill="currentColor"
        />
        <path
          d="M190.983 113.369H165.519V11.0906H190.983V113.369Z"
          fill="currentColor"
        />
      </g>
      <g
        fill="currentColor"
        fill-opacity="1"
      >
        <g transform="translate(461.308173, 116.425687)">
          <g><path d="M 3.09375 0 L 3.09375 -31.921875 L 10.03125 -31.921875 L 20.203125 -11.671875 L 30.234375 -31.921875 L 37.15625 -31.921875 L 37.15625 0 L 31.328125 0 L 31.328125 -22.015625 L 22.4375 -4.5625 L 17.828125 -4.5625 L 8.9375 -22.015625 L 8.9375 0 Z M 3.09375 0 " /></g>
        </g>
      </g>
      <g
        fill="currentColor"
        fill-opacity="1"
      >
        <g transform="translate(501.561219, 116.425687)">
          <g><path d="M 1.546875 0 L 11.53125 -16.140625 L 1.40625 -31.921875 L 8.109375 -31.921875 L 15.28125 -20.796875 L 21.84375 -31.921875 L 28.40625 -31.921875 L 18.421875 -15.859375 L 28.640625 0 L 21.9375 0 L 14.6875 -11.265625 L 8.109375 0 Z M 1.546875 0 " /></g>
        </g>
      </g>
    </svg>
  </span>
</template>
